/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Experience_WordsInputs */

const en_us2_search_field_experience_words = /** @type {(inputs: Search_Field_Experience_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`experience level beginner intermediate advanced`)
};

const pt_br2_search_field_experience_words = /** @type {(inputs: Search_Field_Experience_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`experiencia nivel iniciante intermediario avancado`)
};

const es_419_search_field_experience_words = /** @type {(inputs: Search_Field_Experience_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`experiencia nivel principiante intermedio avanzado`)
};

const pt_pt2_search_field_experience_words = /** @type {(inputs: Search_Field_Experience_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`experiencia nivel principiante iniciante intermedio avancado`)
};

const fr_fr2_search_field_experience_words = /** @type {(inputs: Search_Field_Experience_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`experience niveau debutant intermediaire avance`)
};

const de_de2_search_field_experience_words = /** @type {(inputs: Search_Field_Experience_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erfahrung niveau anfänger fortgeschritten profi`)
};

const it_it2_search_field_experience_words = /** @type {(inputs: Search_Field_Experience_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esperienza livello principiante intermedio avanzato`)
};

/**
* | output |
* | --- |
* | "experience level beginner intermediate advanced" |
*
* @param {Search_Field_Experience_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_experience_words = /** @type {((inputs?: Search_Field_Experience_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Experience_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_experience_words(inputs)
	if (locale === "es-419") return es_419_search_field_experience_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_experience_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_experience_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_experience_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_experience_words(inputs)
	return en_us2_search_field_experience_words(inputs)
});
export { search_field_experience_words as "search.field_experience_words" }